import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { ASSETS } from '../assetManifest.js';
import { CONSTANTS } from '../data.js';
import { getAssetKey } from '../utils/assetUtils.js';
import { getRarityColor, getElementGlow, getRarityGlow } from '../utils/gameUtils.js';

const FusionReveal = ({ fusionResult, onClose }) => {
  const { name, level, isNew } = fusionResult;
  const dragonData = CONSTANTS.DRAGONS[name];

  useEffect(() => {
    const timer = setTimeout(onClose, CONSTANTS.FUSION_REVEAL_DURATION);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="fixed inset-0 bg-black/80 backdrop-blur-xl flex items-center justify-center z-50"
      onClick={onClose}
    >
      <motion.div
        className="text-center relative"
        initial={{ scale: 0.5, y: 100 }}
        animate={{ scale: 1, y: 0 }}
        transition={{ type: 'spring', stiffness: 260, damping: 20, delay: 0.2 }}
      >
        {isNew && (
          <motion.div
            className="absolute -top-8 -left-8 bg-yellow-400 text-black font-mono font-black text-2xl px-4 py-2 rounded-lg transform -rotate-12 shadow-lg z-10"
            initial={{ scale: 0, rotate: -45 }}
            animate={{ scale: 1, rotate: -12 }}
            transition={{ type: 'spring', delay: 1, stiffness: 300, damping: 10 }}
          >
            NEW!
          </motion.div>
        )}
        <motion.img
          src={ASSETS.dragons[getAssetKey(name)].path}
          alt={name}
          className="w-64 h-64"
          style={{ filter: `drop-shadow(0 0 25px ${getElementGlow(dragonData.element)}) drop-shadow(0 0 50px ${getRarityGlow(dragonData.rarity)})` }}
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.5, duration: 0.8, ease: 'backOut' }}
        />
        <motion.h2
          className="text-5xl font-mono font-bold mt-4"
          style={{ color: getRarityColor(dragonData.rarity), textShadow: `0 0 15px ${getRarityColor(dragonData.rarity)}` }}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.2, duration: 0.5 }}
        >
          {name}
        </motion.h2>
        <motion.p
          className="text-2xl text-gray-300 font-sans"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 1.4, duration: 0.5 }}
        >
          {fusionResult.type === 'level_up' ? `Reached Level ${level}!` : 'Discovered!'}
        </motion.p>
      </motion.div>
    </motion.div>
  );
};

export default FusionReveal;
